import ErrorNetwork from './ErrorNetwork';
import ErrorGeneric from './ErrorGeneric';

const FallbackErrorComponent = ({ error, resetErrorBoundary }) => {
  const renderError = () => {
    if (error.isNetworkError || error.networkError) {
      if (window.navigator.onLine) {
        return <ErrorGeneric resetErrorBoundary={resetErrorBoundary} />;
      }

      return <ErrorNetwork resetErrorBoundary={resetErrorBoundary} />;
    }
    return <ErrorGeneric resetErrorBoundary={resetErrorBoundary} />;
  };
  return <>{renderError()}</>;
};

export default FallbackErrorComponent;
